import React from 'react';
import Image from 'next/image';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import styles from '../../styles/cart/CartHeader.module.scss';


const CartItemInfo = (props) => {
    const {product} = props;

    const image = {
        file: product.provider.logo,
        height: product.provider.logoSize ? product.provider.logoSize.height : null,
        width: product.provider.logoSize ? product.provider.logoSize.width: null,
        title: product.provider.societate_nume,
    };

    if (image.file) {
        let ratio = image.width/image.height;
        if (image.width>75) {
            image.width = 75;
            image.height = 75/ratio;
        }
    }
    

    const item = {
        name: `Asigurare RCA pe ${product.vehicle.cerere.durata} luni`,
        info: `Clasa bonus-malus: ${product.clasa_bm}${product.decontareDirecta ? ', Decontare directa' : ''}`,
        price: product.prima,
        currency: 'Lei',
    };

    return (
        <div className={`${styles.cartSummary}`}>
            <div className={styles.image}>
                {image.file ?
                <Image
                    src={image.file}
                    width={image.width}
                    height={image.height}
                    title={image.title}
                    className={`pe-2 ${styles.image}`}
                    layout="fixed"
                />
                :
                <p className="pe-3">{image.title}</p>
                }
            </div>

            <div className="pe-3">
                <p className={styles.productName}>{item.name}</p>
                <p className={styles.productInfo}>{item.info}</p>
            </div>
            <div className={styles.price}>
                {item.price}
                <span className={styles.currency}>Lei</span>
            </div>
        </div>
    )
}

export default CartItemInfo;